/* BTTO native product gallery (replaces GG Product Gallery / pmslider) */
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var stage = root.querySelector('[data-stage]');
    var slides = Array.prototype.slice.call(stage.querySelectorAll('.btto-g__slide'));
    var rail = root.querySelector('[data-rail]');
    var thumbs = rail ? Array.prototype.slice.call(rail.querySelectorAll('.btto-g__thumb')) : [];
    var count = root.querySelector('[data-count]');
    var max = parseInt(root.dataset.maxThumbs, 10) || 6;
    var current = 0;
    var total = slides.length;

    /* "+N" tile when there are more thumbnails than fit */
    if (rail && thumbs.length > max) {
      thumbs.slice(max - 1).forEach(function (t) { t.classList.add('is-overflow'); });
      var more = document.createElement('button');
      more.type = 'button'; more.className = 'btto-g__thumb btto-g__more';
      more.setAttribute('aria-label', 'Show all ' + thumbs.length + ' images');
      more.innerHTML = '<span>+' + (thumbs.length - (max - 1)) + '</span>';
      more.addEventListener('click', function () { openLightbox(Math.max(current, max - 1)); });
      rail.appendChild(more);
    }

    /* Video pill */
    var firstVideo = slides.findIndex(function (s) { return s.dataset.type === 'video' || s.dataset.type === 'external_video'; });
    var pill = root.querySelector('[data-video-pill]');
    if (pill && firstVideo > -1) {
      pill.hidden = false;
      pill.addEventListener('click', function () { go(firstVideo); var v = slides[firstVideo].querySelector('video'); if (v) { try { v.play(); } catch (e) {} } });
    }

    function pauseAll(except) {
      slides.forEach(function (s, i) { if (i !== except) { var v = s.querySelector('video'); if (v && !v.paused) v.pause(); } });
    }
    function setActive(i) {
      current = i;
      if (count) count.textContent = (i + 1) + ' / ' + total;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      var more = rail && rail.querySelector('.btto-g__more');
      if (more) more.classList.toggle('is-active', i >= max - 1);
      root.classList.toggle('is-video', slides[i] && slides[i].dataset.type !== 'image' && slides[i].dataset.type !== 'model');
      pauseAll(i);
    }
    function go(i, instant) {
      i = (i + total) % total;
      stage.scrollTo({ left: slides[i].offsetLeft, behavior: instant ? 'auto' : 'smooth' });
      setActive(i);
    }
    // Keep state in sync with swipes
    var t;
    stage.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var i = Math.round(stage.scrollLeft / stage.clientWidth);
        if (i !== current && slides[i]) setActive(i);
      }, 60);
    }, { passive: true });

    var prev = root.querySelector('.btto-g__main [data-prev]'), next = root.querySelector('.btto-g__main [data-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    thumbs.forEach(function (th) { th.addEventListener('click', function () { go(parseInt(th.dataset.goto, 10)); }); });
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'Enter' && slides[current].dataset.type === 'image') openLightbox(current);
    });
    // Click an image to enlarge
    stage.addEventListener('click', function (e) {
      var img = e.target.closest('.btto-g__img');
      if (img && slides[current].dataset.type !== 'model') openLightbox(current);
    });
    var zoomBtn = root.querySelector('[data-open-lightbox]');
    if (zoomBtn) zoomBtn.addEventListener('click', function () { openLightbox(current); });

    /* ---------- Lightbox ---------- */
    var lb = root.querySelector('[data-lightbox]');
    var lbStage = lb.querySelector('[data-lb-stage]');
    var lbThumbs = lb.querySelector('[data-lb-thumbs]');
    var lbCount = lb.querySelector('[data-lb-count]');
    var imgSlides = slides.map(function (s, i) { return { i: i, el: s }; }).filter(function (x) { return x.el.dataset.type === 'image'; });
    var lbBuilt = false, lbIndex = 0;
    function buildLb() {
      if (lbBuilt) return; lbBuilt = true;
      imgSlides.forEach(function (x, k) {
        var src = x.el.querySelector('img');
        var wrap = document.createElement('div'); wrap.className = 'btto-lb__slide';
        var img = document.createElement('img');
        img.src = src.dataset.zoom || src.currentSrc || src.src; img.alt = src.alt; img.loading = 'lazy'; img.decoding = 'async';
        wrap.appendChild(img);
        wrap.addEventListener('click', function (e) { toggleZoom(wrap, e); });
        wrap.addEventListener('mousemove', function (e) { if (wrap.classList.contains('is-zoomed')) pan(wrap, e); });
        lbStage.appendChild(wrap);
        var tb = document.createElement('button'); tb.type = 'button'; tb.className = 'btto-lb__thumb'; tb.setAttribute('aria-label', 'Image ' + (k + 1));
        var ti = document.createElement('img'); ti.src = (src.currentSrc || src.src).replace(/width=\d+/, 'width=160'); ti.alt = ''; ti.loading = 'lazy';
        tb.appendChild(ti); tb.addEventListener('click', function () { lbGo(k); }); lbThumbs.appendChild(tb);
      });
      var lt;
      lbStage.addEventListener('scroll', function () { clearTimeout(lt); lt = setTimeout(function () { var k = Math.round(lbStage.scrollLeft / lbStage.clientWidth); if (k !== lbIndex) lbSet(k); }, 60); }, { passive: true });
      lb.querySelector('[data-lb-prev]').addEventListener('click', function () { lbGo(lbIndex - 1); });
      lb.querySelector('[data-lb-next]').addEventListener('click', function () { lbGo(lbIndex + 1); });
      lb.querySelector('[data-lb-close]').addEventListener('click', closeLightbox);
      lb.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') lbGo(lbIndex - 1); if (e.key === 'ArrowRight') lbGo(lbIndex + 1); });
      lb.addEventListener('close', function () { document.documentElement.classList.remove('btto-lb-open'); });
    }
    function lbSet(k) {
      lbIndex = k;
      lbCount.textContent = (k + 1) + ' / ' + imgSlides.length;
      Array.prototype.forEach.call(lbThumbs.children, function (c, j) { c.classList.toggle('is-active', j === k); if (j === k && c.scrollIntoView) c.scrollIntoView({ block: 'nearest', inline: 'center' }); });
      Array.prototype.forEach.call(lbStage.children, function (c) { c.classList.remove('is-zoomed'); c.style.removeProperty('--ox'); c.style.removeProperty('--oy'); });
    }
    function lbGo(k, instant) {
      var n = imgSlides.length; k = (k + n) % n;
      lbStage.scrollTo({ left: lbStage.children[k].offsetLeft, behavior: instant ? 'auto' : 'smooth' });
      lbSet(k);
    }
    function openLightbox(slideIndex) {
      if (!imgSlides.length) return;
      buildLb();
      var k = imgSlides.findIndex(function (x) { return x.i >= slideIndex; }); if (k < 0) k = 0;
      if (typeof lb.showModal === 'function') lb.showModal(); else lb.setAttribute('open', '');
      document.documentElement.classList.add('btto-lb-open');
      requestAnimationFrame(function () { lbGo(k, true); });
    }
    function closeLightbox() {
      if (typeof lb.close === 'function') lb.close(); else lb.removeAttribute('open');
      document.documentElement.classList.remove('btto-lb-open');
      var k = imgSlides[lbIndex]; if (k) go(k.i, true);
    }
    function pan(wrap, e) {
      var r = wrap.getBoundingClientRect();
      wrap.style.setProperty('--ox', ((e.clientX - r.left) / r.width * 100) + '%');
      wrap.style.setProperty('--oy', ((e.clientY - r.top) / r.height * 100) + '%');
    }
    function toggleZoom(wrap, e) { pan(wrap, e); wrap.classList.toggle('is-zoomed'); }

    /* ---------- Variant image switching ---------- */
    function productJson() { var s = document.querySelector('script[id^="ProductJson-"]'); try { return s ? JSON.parse(s.textContent) : null; } catch (e) { return null; } }
    document.addEventListener('change', function (e) {
      if (!e.target.closest('.product-detail form, .product-detail [data-option-selector]')) return;
      setTimeout(function () {
        var p = productJson(); var input = document.querySelector('.product-detail form[action*="/cart/add"] input[name="id"]');
        if (!p || !input) return;
        var v = p.variants.filter(function (x) { return String(x.id) === String(input.value); })[0];
        if (!v || !v.featured_media) return;
        var k = slides.findIndex(function (s) { return s.dataset.mediaId === String(v.featured_media.id); });
        if (k > -1) go(k);
      }, 80);
    });

    // Start position (selected variant image)
    var sm = root.dataset.startMedia;
    var sk = sm ? slides.findIndex(function (s) { return s.dataset.mediaId === sm; }) : -1;
    if (sk > 0) requestAnimationFrame(function () { go(sk, true); }); else setActive(0);
  }
  function boot() { document.querySelectorAll('[data-btto-gallery]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
